import styled, { css } from 'styled-components';

export const MobileTopWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1.03rem 1.6rem;
  border-bottom: 0.1rem solid #42464d;
  z-index: 1001;
  align-items: center;

  ${({ theme }) => theme.quantum.media.tablet`
    display: none;
  `}
`;

export const BurgerIconWrapper = styled.button`
  appearance: none;
  border: 0;
  background: transparent;
  height: 2.4rem;
  margin: 0;
  padding: 0;
  position: relative;
  display: flex;
  justify-content: center;
  cursor: pointer;
  transition: all 0.5s ease-in-out;
`;

export const BurgerIcon = styled.span`
  width: 2rem;
  display: flex;
  height: 0.2rem;
  background: #bdc4cf;
  border-radius: 0.2rem;
  transition: all 0.2s ease-in-out;
  margin-top: 1.2rem;
  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 2rem;
    height: 0.2rem;
    background: #bdc4cf;
    border-radius: 0.2rem;
    transition: all 0.2s ease-in-out;
  }
  &::before {
    transform: translateY(-0.7rem);
  }
  &::after {
    transform: translateY(0.7rem);
  }

  ${({ isOpen }) =>
    isOpen &&
    css`
      background: green;
      transform: translateX(-2rem);
      background: transparent;
      box-shadow: none;
      &::before {
        transform: rotate(45deg) translate(1.2rem, -1.2rem);
      }
      &::after {
        transform: rotate(-45deg) translate(1.2rem, 1.2rem);
      }
    `}
`;

export const MobileWrapper = styled.nav`
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  z-index: 100;
  top: 6.5rem;
  left: 0;
  right: 0;
  bottom: 0;
  background: #1e212a;
  overflow: auto;
  scrollbar-width: none;
  height: calc(100% - 20.9rem);

  ::-webkit-scrollbar {
    display: none;
  }

  ${({ theme }) => theme.quantum.media.tablet`
    display: none;
  `}
`;

export const MobileSummary = styled.summary`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2.4rem 2.4rem 2.4rem 1.6rem;
  border-bottom: 0.1rem solid #42464d;
  cursor: pointer;

  span {
    transition: all 0.25s ease;
  }

  svg {
    transform: scale(1.8);
    transition: all 0.25s ease;
  }
`;

export const MobileDetails = styled.details`
  display: block;

  summary {
    ::-webkit-details-marker {
      display: none;
    }
  }

  &[open] summary span {
    color: #bcbaff;
  }

  &[open] summary svg {
    transform: rotate(-180deg) scale(1.8);
  }

  &[open] summary svg path {
    stroke: #bcbaff;
  }
`;

export const MobileSubMenu = styled.div`
  padding: 2.4rem 1.6rem 3.6rem;

  :first-child {
    border-top: 0.1rem solid #42464d;
  }

  :last-child {
    border-bottom: 0.1rem solid #42464d;
  }

  + div {
    padding-top: 0.4rem;
  }
`;

export const MobileSubsectionTitle = styled.p`
  font-family: 'SpaceGrotesk', sans-serif;
  font-weight: 500;
  font-size: 1.4rem;
  line-height: 2rem;
  letter-spacing: 0.15rem;
  text-transform: uppercase;
  margin: 0 0 2rem;
  color: #8c929c;
`;

export const MobileList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

export const MobileListItem = styled.li`
  a {
    color: white;
    font-size: 2rem;
    letter-spacing: -0.01rem;
    font-weight: 500;
    :hover {
      color: #bcbaff;
    }
  }

  + li {
    margin-top: 2rem;
  }
`;

export const CTAsWrapper = styled.div`
  display: grid;
  grid-template-areas: /* stylelint-disable-line declaration-colon-space-after */
    '. .'
    'contact contact';
  grid-gap: 1.6rem;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 1.6rem;
  border-top: 0.1rem solid #42464d;
  background: #1e212a;

  a:nth-child(3) {
    grid-area: contact;
  }
`;
